
type TDropdownTitleProps = {
  title: any; // really: React element or a string
  direction?: 'up' | 'down';
  className?: string;
};

export function DropdownTitle(props: TDropdownTitleProps) {
  return (
    <span className={props.className}>
      {props.title} &nbsp;
      <i className={`fa fa-caret-${props.direction || 'down'} text-raiderio`} />
    </span>
  );
}
